export const CDA_KEY = 'CdAN_xG3';
export const PALETTE = [
  '#008FFB',
  '#00E396',
  '#FEB019',
  '#FF4560',
  '#775DD0',
  '#546E7A',
  '#D4526E',
  '#8D5B4C',
  '#F86624',
];

export const LINE_COLOR = '#3F51B5';
